import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { useLocation } from 'src/utils/Hooks';
import { useGenericSideBarStyles } from 'src/components/BeaconV2Components/GenericSidebarNav/GenericSidebar';
import {
  BEACON_PRO_SIDEBAR_WIDTH,
  BEACON_PRO_RIGHT_CONTENT_WIDTH,
  BEACON_PRO_SIDEBAR_RIGHT_PADDING
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { useAtlasV2SettingRoutes } from 'src/components/AtlasV2Components/AtlasV2Settings/AtlasV2SettingRoutesConfig';
import { NewSettingsLayoutProps } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/NewSettingsLayout';
import { AppLinkTabs } from 'src/components/GlobalComponents/PrimaryPageNavigation/AppLinkTabs';

const SidebarContainer = styled('div')({
  width: BEACON_PRO_SIDEBAR_WIDTH
});

/**
 *  New settings page layout with Navigation.
 */
const AtlasV2SettingsPageLayout = (props: NewSettingsLayoutProps) => {
  const classes = useGenericSideBarStyles();
  const settingRoutes = useAtlasV2SettingRoutes(props);
  const { pathname } = useLocation();

  const visibleRoutes = useMemo(() => {
    return settingRoutes.filter((route) => !route.hidden);
  }, [settingRoutes]);

  const activeIndex = useMemo(() => {
    const currentRoute = settingRoutes.find((routeObject) => routeObject.route.includes(pathname)) || settingRoutes[0];
    // Find the index in the visible routes array
    const visibleIndex = visibleRoutes.findIndex((visibleRoute) => visibleRoute.index === currentRoute.index);
    return visibleIndex >= 0 ? visibleIndex : 0;
  }, [pathname, settingRoutes, visibleRoutes]);

  return (
    <div style={{ display: 'flex', gap: BEACON_PRO_SIDEBAR_RIGHT_PADDING }}>
      <SidebarContainer>
        <div>
          <Text variant="h4">Settings</Text>
        </div>
        <AppLinkTabs
          tabIndex={activeIndex}
          setTabIndex={() => {}}
          tabRoutes={visibleRoutes.map((route, index) => ({ ...route, index }))}
          tabsProps={{
            classes: {
              root: classes.tabs
            }
          }}
          containerStyle={{
            marginLeft: 0,
            marginRight: 0
          }}
          tabProps={{
            classes: {
              root: classes.tab
            }
          }}
        />
      </SidebarContainer>
      <Flex>
        <div style={{ width: BEACON_PRO_RIGHT_CONTENT_WIDTH }}>{visibleRoutes[activeIndex]?.renderComponent}</div>
      </Flex>
    </div>
  );
};

export default AtlasV2SettingsPageLayout;
